import { boolean, z } from "zod";
export const QualidadeAcoesPreventivasSchema = z.object({
  IdAcaoPrevCorretiva: z.number().nullable().optional(),
  IdAcaoQualidade: z.number().nullable().optional(),
  Tipo: z.number(), 
  Numero: z.number().nullable().optional(),
  IdentificadoPor: z.string().nullable().optional(),
  DescricaoSetor: z.string({
    required_error: "O campo é obrigatório", 
    invalid_type_error: "O campo é obrigatório", 
  }).min(1, "O campo é obrigatório"),

  Abrangencia: z.string().nullable().optional(),
  AnaliseCausa: z.string().nullable().optional(),
  Assunto: z.string().nullable().optional(),
  DescricaoProblema: z.string().nullable().optional(),
  Evento: z.string().nullable().optional(),
  EvidenciaObjetiva: z.string().nullable().optional(),
  RequisitoNorma: z.string().nullable().optional(),
  Justificativa: z.string().nullable().optional(),
  Data: z.coerce.date().nullable().optional(),
  
  IdCentroCusto: z.number({
    required_error: "O campo é obrigatório", 
    invalid_type_error: "O campo é obrigatório", 
  }).min(1, "O campo é obrigatório"),

  AcaoAberta: z.coerce.number(),
  RealizarAnalise: z.any()
    .nullable()
    .optional()
    .transform(val => {
        // Converte qualquer entrada (1, "1", true) para true
        if (val === 1 || val === "1" || val === true) return true; 
        
        // Converte qualquer entrada (0, "0", false) para false
        if (val === 0 || val === "0" || val === false) return false; 
        
        return null;
    }),
  arquivo1: z.any().nullable().optional(),
  arquivo2: z.any().nullable().optional(),
  arquivo3: z.any().nullable().optional(),
  arquivo4: z.any().nullable().optional(),
  arquivo5: z.any().nullable().optional(),
  nomeArquivo1: z.string().nullable().optional(),
  nomeArquivo2: z.string().nullable().optional(),
  nomeArquivo3: z.string().nullable().optional(),
  nomeArquivo4: z.string().nullable().optional(),
  nomeArquivo5: z.string().nullable().optional(),
  limparArquivo1: z.boolean().default(false),
  limparArquivo2: z.boolean().default(false),
  limparArquivo3: z.boolean().default(false),
  limparArquivo4: z.boolean().default(false),
  limparArquivo5: z.boolean().default(false),
});


export type QualidadeAcoesPreventivasForm = z.infer<typeof QualidadeAcoesPreventivasSchema>;